var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-chips-container"},_vm._l((_vm.chips),function(chip,index){return _c('v-chip',{key:`chip_${index}`,style:(`cursor: ${_vm.cursor};`),attrs:{"pill":"","color":_vm.chipColor}},[_c('v-avatar',{attrs:{"left":""}},[_c('v-img',{attrs:{"src":chip.picture}})],1),_vm._v(" "+_vm._s(chip.name)+" ")],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }